module.exports = __webpack_public_path__ + "media/images/micro-ondes-e274a81f81d9a074d17ddfba80ac817b.svg";